<template>
  <div>
    <!-- Breadcrumb Section Begin -->
    <div class="breacrumb-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-text">
                      <router-link to="/"><i class="fa fa-home"></i> {{ $t('nav.home') }}</router-link>
                        <span>{{ $t('breadcrumb.generalInfo') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Breadcrumb Section Begin -->
    <!-- Politicas e termos -->
    <section class="product-shop spad">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-8 order-2 order-lg-1 produts-sidebar-filter">
                    <div class="filter-widget">
                        <h4 class="fw-title">{{ $t('info.policiesTerms') }}</h4>
                        <ul class="filter-catagories" v-if="informacoes!=''">
                            <li  v-for="itens in informacoes" :key="itens.itiId">
                              <a href="#" @click.prevent="carregaTexto(itens.itiId)"> {{ $localeField(itens, 'itiNome') }}</a>
                            </li>
                        </ul>
                    </div>

                </div>
                <!-- dropdown meses -->
                <div class="col-lg-9 order-1 order-lg-2" v-if="informacao!=''">
                    <h2> {{ $localeField(informacao[0], 'itiNome') }}</h2><br>
                    <p v-html="$localeHtml(informacao[0], 'itiResumo1')"></p>
                </div>
            </div>
        </div>
    </section>
    <!-- politicas e termos final -->  
  </div>
</template>

<script>
//import moment from 'moment'
import axios from 'axios';
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';

export default {
  name: 'InformacoesView',
  setup() {
    const route = useRoute();
    const id = route.params.idInformacoes;
    return {
      id
    };
  },
  components: {
  },
  data: () => ({
    informacoestopo: [],
    informacoes: [],
    informacao:[],
    infocall: [],
  }),
  methods: {
    carregaMetas() {
      useHead({
        title: 'Informações - Sub4 Turismo'
      })
    },
    carregaTexto(value) {
      this.informacao = this.informacoes.filter(x => x.itiId == value)
    },
  },
  created() {

    this.carregaMetas();

    axios.get('/Process/InsInstitucional/institucional/18/informacoes')
      .then(response => {
        this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);

        if (this.id) {
          this.carregaTexto(this.id);
        }
        else {
          this.carregaTexto(this.informacoes[0].itiId);
        }
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style>.hhss {
  display: none;
}

.sli p {
  color: #ede3e3 !important;
}</style>
